import React from "react";
import Slider from "react-slick";
import { Button, Modal, Row, Col, ListGroup, Card, Container, ButtonGroup  } from 'react-bootstrap';

import DownloadButtonPartial from "./DownloadButtonPartial";

import * as functionHelper from '../common/functions';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"

const ItemsCarouselPartial = ({items, language}) => {

  const settings = {
    dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 3

  };

  const maxChars = 40;

  

  return(
    <div>
      <h2> Podobne </h2>
      <Row>
          <Slider {...settings}>

            {
              items.map((item, key) => {
                const title = item.name.length > maxChars ? item.name.slice(0, maxChars) + '...' : item.name;
                const uniqueSeries = functionHelper.getUniqueSeriesNames(item.series);
                const link ="https://baza-wiedzy.klett.pl/" + language + "/" +item.categories.at(0).slug+"/"+item.slug+","+item.kId

                const date = new Date(item.dates.createdAt)
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są liczone od 0, dlatego dodajemy 1
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');

                return(
                  <Col sm={12} md={6} lg={3} className="p-2" key={key}>
                    <Card className="sliderItem">
                    
                    <Card.Body>
                        <Card.Title><strong>{title}</strong></Card.Title>
                        <Card.Text>
                          <small>Data ostatniej aktualizacji<br/><strong>{year}-{month}-{day} {hours}:{minutes}</strong></small>
                        </Card.Text>
                        <ul className="list-inline seriesList">
                          {
                            
                            uniqueSeries.map((series, key) => {
                              return (
                                <React.Fragment key={key}>
                                  <li className="list-inline-item"><small>{series}</small></li>
                                </React.Fragment>
                              );
                            })
                          }
                        </ul>
                      </Card.Body>
                      <Card.Footer>
                        
                        <Row>
                          <Col sm={12} md={9} lg={9}>
                            <div className="d-grid gap-2"><a href={link} className="btn btn-primary">Szczegóły</a></div>
                          </Col>
                          <Col sm={12} md={3} lg={3}>
                            <div className="d-grid gap-2"><DownloadButtonPartial item={item} language={language} /></div>
                          </Col>
                        </Row>

                      </Card.Footer>
                    </Card>
                  </Col>
                )
              })
            }
            
            

           

          </Slider>
        </Row>
    </div>
  )

}
export default ItemsCarouselPartial